import BulkMediaUploadPanel, { type UploadResult } from "@/components/admin/BulkMediaUploadPanel";

interface ExistingAsset {
  fileName: string;
  fileUrl: string;
}

interface InfographicUploadPanelProps {
  onUploadComplete: (results: UploadResult[]) => void;
  existingFileNames?: string[];
  existingAssets?: ExistingAsset[];
}

export default function InfographicUploadPanel({ onUploadComplete, existingFileNames = [], existingAssets = [] }: InfographicUploadPanelProps) {
  return (
    <BulkMediaUploadPanel
      bucketName="infographics"
      uploadPathPrefix="uploads"
      accept="image/png,image/jpeg,image/jpg,image/webp"
      validMimeTypes={["image/png", "image/jpeg", "image/jpg", "image/webp"]}
      mediaLabel="Infographics"
      helperText="PNG, JPG, WEBP — Upload one or many files at once"
      existingFileNames={existingFileNames}
      existingAssets={existingAssets}
      onUploadComplete={onUploadComplete}
    />
  );
}
